import { NavigationType, type Location } from 'react-router-dom';

/** The part of a data router this needs, so a test can hand it a memory router. */
export interface INavigationSource {
  readonly state: { readonly location: Location; readonly historyAction: NavigationType };
  subscribe(listener: (state: INavigationSource['state']) => void): () => void;
}

/**
 * Calls `onNavigate` each time the reader moves to another screen: a link, a back or a forward.
 *
 * ⛔ A `replace` is not counted. The app rewrites its own address in place — a slug made canonical,
 * a selection written into the query — without the reader doing anything, and what hangs off this
 * (I-0781: taking a new deployment with a reload) must never happen to a screen nobody left.
 */
export function subscribeToReaderNavigation(
  router: INavigationSource,
  onNavigate: () => void,
): () => void {
  let shown = router.state.location;
  return router.subscribe((state) => {
    if (state.location === shown) return;
    shown = state.location;
    if (state.historyAction === NavigationType.Replace) return;
    onNavigate();
  });
}
